import React from "react";
import { Wrapper } from "./styles";

export default function ContainerHome({ infoBlocks = [], isDarkMode }) {
  return (
    <Wrapper>
      <div className="ContainerHome">
        {infoBlocks.map(({ iconeLight, iconeDark, alt, subtitle, description }, index) => (
          <div className="InfoBlock" key={index}>
            <div className="IconHome">
              <img
                src={isDarkMode ? iconeDark : iconeLight}
                alt={alt}
              />
            </div>
            <div className="SubtitleHome">{subtitle}</div>
            <div className="DescriptionHome">{description}</div>
          </div>
        ))}
      </div>
    </Wrapper>
  );
}
